/**
 * util version for generating productIntegration block for pulse and google analutic
 * tracking data. As specified by the analytics parameters document.
 */

const pi = (featuredPlacements) =>
  featuredPlacements.map((fp) => ({
    name: 'premiumWarranty',
    integrationType: fp.shortLabel,
    /**
     * Version is a number we in adout create, that indicates which version of this format
     * that is used. So if we change this object we should bump the version number here,
     * enabling the data people to filter on the version dimension.
     */
    version: '1.0.0',
  }))

export default pi
